module.exports = __webpack_public_path__ + "media/application/images/svgs/mic-off-5f3a370d6fb902657bf4912f821f10f7.svg";